import { Component, Mixins } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IBericht } from '@/model/IBericht';
import { State } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import { find, orderBy } from 'lodash';

@Component({
  components: {
    'vue-markdown': VueMarkdown
  }
})
export default class AppBerichten extends Mixins(AppFiltersMixin) {
  @State(state => state.berichten)
  public berichten!: IBericht[];

  public get sortedBerichten(): IBericht[] {
    return orderBy(this.berichten, ['read'], ['asc']);
  }

  public get displayBerichten(): IBericht[] {
    return this.sortedBerichten.slice(0, 2);
  }

  public get hasNone(): boolean {
    return !this.sortedBerichten.length;
  }

  public get hasMore(): boolean {
    return this.sortedBerichten.length > 2;
  }

  public isOngelezen(bericht: IBericht) {
    return !bericht.gelezen || !!find(bericht.documenten, d => !d.gelezen);
  }
}
